<template>
    <div v-if="research.id">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Painel de Controle - {{ research.name }}
                            <button
                                class="btn btn-normal float-right"
                                @click="advance()"
                                v-if="research.status_id < 9"
                            >
                            <span v-if="research.status_id > 1">
                                Avançar Etapa
                            </span>
                            <span v-if="research.status_id == 1">
                                Iniciar Pesquisa
                            </span>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div
                                    :class="['cp-status-cell inline-block', {'bg-red': research.status_id == 999}]"
                                >
                                    Cancelada
                                    <hr class="little-margin-hr" />
                                    <br />-
                                    <hr class="little-margin-hr" />
                                    <div v-if="research.status_id == 999">
                                        Realizado:
                                        <br />
                                        {{ formatDate(research.indeed_canceled) }}
                                    </div>
                                    <div v-if="!(research.status_id == 999)">
                                        <br />-
                                    </div>
                                </div>
                                <div
                                    :class="['cp-status-cell inline-block', {'bg-green': [2,3].includes(research.status_id)}]"
                                >
                                    Aplicação
                                    <span
                                        class="badge badge-success"
                                        v-if="research.status_id == 2"
                                    >Em andamento</span>
                                    <span
                                        class="badge badge-secondary"
                                        v-if="research.status_id == 3"
                                    >Finalizado</span>

                                    <hr class="little-margin-hr" />Previsto:
                                    <br />
                                    {{ formatDate(research.apply_start_date) }} - {{ formatDate(research.apply_end_date) }}
                                    <hr class="little-margin-hr" />Realizado:
                                    <br />
                                    {{ formatDate(research.indeed_apply_start_date) }} - {{ formatDate(research.indeed_apply_end_date) }}
                                </div>
                                <div
                                    :class="['cp-status-cell inline-block', {'bg-green': [4,5].includes(research.status_id)}]"
                                >
                                    Análise
                                    <span
                                        class="badge badge-success"
                                        v-if="research.status_id == 4"
                                    >Em andamento</span>
                                    <span
                                        class="badge badge-secondary"
                                        v-if="research.status_id == 5"
                                    >Finalizado</span>
                                    <hr class="little-margin-hr" />Previsto:
                                    <br />
                                    {{ formatDate(research.analisys_start_date) }} - {{ formatDate(research.analisys_end_date) }}
                                    <hr class="little-margin-hr" />Realizado:
                                    <br />
                                    {{ formatDate(research.indeed_analisys_start_date) }} - {{ formatDate(research.indeed_analisys_end_date) }}
                                </div>
                                <div
                                    :class="['cp-status-cell inline-block', {'bg-green': [6,7].includes(research.status_id)}]"
                                >
                                    Divulgação
                                    <span
                                        class="badge badge-success"
                                        v-if="research.status_id == 6"
                                    >Em andamento</span>
                                    <span
                                        class="badge badge-secondary"
                                        v-if="research.status_id == 7"
                                    >Finalizado</span>
                                    <hr class="little-margin-hr" />Previsto:
                                    <br />
                                    {{ formatDate(research.disclosure_start_date) }} - {{ formatDate(research.disclosure_end_date) }}
                                    <hr class="little-margin-hr" />Realizado:
                                    <br />
                                    {{ formatDate(research.indeed_disclosure_start_date) }} - {{ formatDate(research.indeed_disclosure_end_date) }}
                                </div>
                                <div
                                    :class="['cp-status-cell inline-block', {'bg-green': [8,9].includes(research.status_id)}]"
                                >
                                    Plano de Ação
                                    <span
                                        class="badge badge-success"
                                        v-if="research.status_id == 8"
                                    >Em andamento</span>
                                    <span
                                        class="badge badge-secondary"
                                        v-if="research.status_id == 9"
                                    >Finalizado</span>
                                    <hr class="little-margin-hr" />Previsto:
                                    <br />
                                    {{ formatDate(research.action_start_date) }} - {{ formatDate(research.action_end_date) }}
                                    <hr class="little-margin-hr" />Realizado:
                                    <br />
                                    {{ formatDate(research.indeed_action_start_date) }} - {{ formatDate(research.indeed_action_end_date) }}
                                </div>
                            </div>
                        </div>
                        <div class="title-underlined mt-5">Clima geral da pesquisa</div>
                        <div class="row mt-5 mb-5">
                            <div class="col-md-6 centered">
                                <div class="sentiment-box inline" id="positive">
                                    <div class="title">Positivo</div>
                                    <div
                                        class="percentage"
                                    >{{ sentiment.sentimentsPercentage.positive }}%</div>
                                </div>
                                <div class="sentiment-box inline" id="neutral">
                                    <div class="title">Neutro</div>
                                    <div
                                        class="percentage"
                                    >{{ sentiment.sentimentsPercentage.neutral }}%</div>
                                </div>
                                <div class="sentiment-box inline" id="negative">
                                    <div class="title">Negativo</div>
                                    <div
                                        class="percentage"
                                    >{{ sentiment.sentimentsPercentage.negative }}%</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <horizontal-bar
                                    v-if="sentiment.sentimentGraph"
                                    :chart-data="sentiment.sentimentGraph"
                                    :styles="sentimentGraphStyle"
                                    :options="sentimentOption"
                                ></horizontal-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HorizontalBar from "../Charts/HorizontalBar.js";
import BaseCrud from "./../Base/BaseCrud";
export default {
    data() {
        return {
            statusList: [],
            research: {},
            researchDash: null,
            sentimentGraphStyle: {
                height: `150px`
            },
            sentimentOption: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true
                },
                hover: {
                    animationDuration: 30
                },
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                fontFamily: "'Open Sans Bold', sans-serif",
                                fontSize: 11,
                                max: 100
                            },
                            scaleLabel: {
                                display: false
                            },
                            gridLines: {},
                            stacked: true
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                color: "red",
                                zeroLineColor: "red",
                                zeroLineWidth: 0
                            },
                            ticks: {
                                fontFamily: "'Open Sans Bold', sans-serif",
                                fontSize: 13,
                                fontStyle: "bold"
                            },
                            stacked: true
                        }
                    ]
                },
                legend: {
                    display: true
                },

                pointLabelFontFamily: "Quadon Extra Bold",
                scaleFontFamily: "Quadon Extra Bold"
            }
        };
    },
    computed: {
        sentiment() {
            let counter = 0;
            let sentiments = {
                positive: 0,
                neutral: 0,
                negative: 0
            };
            if (this.researchDash) {
                this.researchDash.asks.forEach(ask => {
                    if (ask.type_id == 1) {
                        ask.answer_scales.forEach(answer => {
                            let scaleTotal =
                                (answer.department + answer.company) / 2;
                            if (scaleTotal < 2) {
                                sentiments.negative++;
                            } else if (scaleTotal == 2) {
                                sentiments.neutral++;
                            } else {
                                sentiments.positive++;
                            }
                            counter++;
                        });
                    } else if (ask.type_id == 3) {
                        ask.answer_essays.forEach(answer => {
                            let arrayToOrder = [
                                {
                                    label: "positive",
                                    value: answer.sentiment_positive
                                },
                                {
                                    label: "negative",
                                    value: answer.sentiment_negative
                                },
                                {
                                    label: "neutral",
                                    value: answer.sentiment_neutral
                                }
                            ];

                            arrayToOrder.sort((a, b) => {
                                if (a.value < b.value) return 1;
                                else if (a.value > b.value) return -1;
                                else return 0;
                            });

                            sentiments[arrayToOrder[0].label]++;
                            counter++;
                        });
                    }
                });
            }

            let sentimentsPercentage = {
                positive: 0,
                neutral: 0,
                negative: 0
            };

            for (let index in sentiments) {
                if (sentiments[index]) {
                    sentimentsPercentage[index] = (
                        (sentiments[index] * 100) /
                        counter
                    ).toFixed(2);
                }
            }

            let sentimentGraph = {
                labels: ['Clima geral'],
                datasets: [
                    {
                        data: [sentimentsPercentage.positive],
                        backgroundColor: "#8ad650",
                        borderWidth: "2",
                        label: "Positivo",
                        barThickness: 30
                    },
                    {
                        data: [sentimentsPercentage.neutral],
                        backgroundColor: "#ddda2e",
                        borderWidth: "2",
                        label: "Neutro",
                        barThickness: 30
                    },
                    {
                        data: [sentimentsPercentage.negative],
                        backgroundColor: "#f74922",
                        borderWidth: "2",
                        label: "Negativo",
                        barThickness: 30
                    }
                ]
            };

            return {
                sentimentsPercentage: sentimentsPercentage,
                sentimentGraph: sentimentGraph
            };
        },
        statusListFiltered() {
            let filtered = this.statusList.filter(x =>
                [2, 4, 6, 8, 10].includes(x.id)
            );
            filtered.sort(x => {
                if (x.id == 10) return -1;
            });
            return filtered;
        }
    },
    methods: {
        formatDate(dateTime) {
            if (dateTime) {
                return moment(dateTime).format("DD/MM/YYYY HH:mm");
            } else {
                return "";
            }
        },
        getStatus() {
            const self = this;
            const api = self.$store.state.api + "researchstatus";
            self.$http
                .get(api)
                .then(response => {
                    self.statusList = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getResearch() {
            const self = this;
            const id = this.$route.params.id;
            const api = self.$store.state.api + "researches/" + id;
            self.$http
                .get(api)
                .then(response => {
                    self.research = response.data.data[0];
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getResearchDash() {
            const self = this;
            let api =
                self.$store.state.api +
                "researches/dash/" +
                self.$route.params.id;
            self.$http
                .get(api)
                .then(response => {
                    self.researchDash = response.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        advance() {
            const self = this;
            swal({
                title: "Deseja avançar a etapa da pesquisa?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, avançar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            }).then(value => {
                switch (value) {
                    case "cancel":
                        break;

                    case "confirm":
                        const api =
                            self.$store.state.api + "researches/advanceById";
                        self.$http
                            .post(api, {
                                research_id: self.$route.params.id
                            })
                            .then(response => {
                                self.getResearch();
                                self.$message(
                                    "Sucesso",
                                    "Pesquisa avançada com sucesso",
                                    "success"
                                );
                            })
                            .catch(error => {
                                self.$message(
                                    "Erro",
                                    error.response.data,
                                    "error"
                                );
                            });
                        break;
                }
            });
        }
    },
    mounted: function() {
        this.getResearch();
        this.getStatus();
        this.getResearchDash();
    },
    components: {
        HorizontalBar
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Research/ControlPanel.vue